import { z } from 'zod'
import { AnexoSchema } from './socioeducation-measure-procedural-data.type'
import { selectIdFieldSchema } from 'utils/schema.util'

export type SocioeducationAccompanimentDataType = z.infer<
  typeof SocioeducationAccompanimentDataSchema
>

export const SocioeducationAccompanimentDataSchema = z.object({
  id: z.number().nullish(),
  meioAbertoAcompInfoEscolaAprendTrabalho: z
    .object({
      matriculado: z.string().nullish(),
      anoParadaEstudo: z.string().nullish(),
      unidadeEnsino: z.string().nullish(),
      anoEscolar: z.number().nullish(),
      turnoEscolarizacao: z.string().nullish(),
      anoParou: z.string().nullish(),
      anoConclusaoEstudo: z.number().nullish(),
      frequencia: z.string().nullish(),
      vinculoEscolar: z.string().nullish(),
      jovemAprendiz: z.string().nullish(),
      dataInicio: z.string().nullish(),
      empresa: z.string().nullish(),
      contato: z.string().nullish(),
      turnoJovemAprendiz: z.string().nullish(),
      motivoNaoAdesao: z.string().nullish(),
      motivoNaoInserido: z.string().nullish(),
      oportunidadesJovemAprendizEcaminhadas: z.string().nullish(),
      apresentaAreaInteresse: z.string().nullish(),
      objetivoAreaInteresse: z.string().nullish(),
      trabalho: z.string().nullish(),
      ativadades: z.string().nullish(),
      local: z.string().nullish(),
      turnoTrabalho: z.string().nullish(),
      remuneracao: z.number().nullish(),
      idValorRemuneracao: selectIdFieldSchema,
      observacao: z.string().nullish(),
      engressoTrabalhoInfantil: z.string().nullish(),
      atividadeTrabalhoInfantil: z.string().nullish(),
      profissionalizacao: z.string().nullish(),
      cursoProfissionalizante: z.string().nullish(),
      renda: z
        .object({
          id: z.number().nullish(),
          descricao: z.string().nullish(),
        })
        .nullish(),
    })
    .nullish(),
  meioAbertoAcompInfoSaudeIntegral: z
    .object({
      vinculadoUnidadeSaude: z.string().nullish(),
      unidadeSaude: z.string().nullish(),
      clinicaDeFamiliaDeReferencia: z.string().nullish(),
      possuiPlanoParticular: z.string().nullish(),
      projetoTerapeuticoSingularOuSaudeCompUnSaude: z.string().nullish(),
      possuiDoencaCronica: z.string().nullish(),
      doencasCronicas: z.string().nullish(),
      possuiDeficiencia: z.string().nullish(),
      deficiencia: z.string().nullish(),
      possuiAcompanhamentoSaudeMental: z.string().nullish(),
      acompanhamentoSaudeMental: z.string().nullish(),
      unidadeSaudeMental: z.string().nullish(),
      fazUsoDrogasLicitasIlicitas: z.string().nullish(),
      substancias: z.object({
        usaBebida: z.string().nullish(),
        usaCigarro: z.string().nullish(),
        usaCocaina: z.string().nullish(),
        usaCrack: z.string().nullish(),
        usaHaxixe: z.string().nullish(),
        usaHeroina: z.string().nullish(),
        usaLolo: z.string().nullish(),
        usaMaconha: z.string().nullish(),
        usaOutros: z.string().nullish(),
        usaSubstancia: z.string().nullish(),
      }),
      relacaoAdolescenteDroga: z.string().nullish(),
      avaliacaoResponsaveisUsoDroga: z.string().nullish(),
      possuiLaudoDeficienciaIntelectual: z.string().nullish(),
      revisaoMedicaTranstornoOuDeficienciaIntelectual: z.string().nullish(),
      obsevacoes: z.string().nullish(),
      anexo: AnexoSchema.nullish(),
    })
    .nullish(),
  meioAbertoAcompInfoCulturaEsporte: z
    .object({
      areaInteresseCultura: z.string().nullish(),
      possuiIdJovemParaAtividadesCulturais: z.string().nullish(),
      areaInteresseEsporte: z.string().nullish(),
      observacoes: z.string().nullish(),
    })
    .nullish(),
  meioAbertoAcompInfoRedeSocioassistencial: z
    .object({
      crasReferencia: z.string().nullish(),
      participaServConvFortaleciementoVinculo: z.string().nullish(),
      participaProjetosSociais: z.string().nullish(),
      atividadeProjetoSocial: z.string().nullish(),
      familiaAcompanhaOutroServico: z.string().nullish(),
      familiaInseridaCadUnico: z.string().nullish(),
      familiaBeneProgTransfRendaFederal: z.string().nullish(),
      adolescenteBeneBPC: z.string().nullish(),
      familiaAtendidaOutroProgSociais: z.string().nullish(),
      programaOuBeneficiosSociais: z.string().nullish(),
    })
    .nullish(),
})

export const SocioeducationAccompanimentDataDefaultValues: SocioeducationAccompanimentDataType = {
  meioAbertoAcompInfoEscolaAprendTrabalho: {
    matriculado: '',
    anoParadaEstudo: '',
    unidadeEnsino: '',
    anoEscolar: null,
    turnoEscolarizacao: '',
    anoParou: '',
    anoConclusaoEstudo: null,
    frequencia: '',
    vinculoEscolar: '',
    jovemAprendiz: '',
    empresa: '',
    contato: '',
    turnoJovemAprendiz: '',
    motivoNaoAdesao: '',
    motivoNaoInserido: '',
    oportunidadesJovemAprendizEcaminhadas: '',
    apresentaAreaInteresse: '',
    objetivoAreaInteresse: '',
    trabalho: '',
    ativadades: '',
    local: '',
    turnoTrabalho: '',
    remuneracao: 0,
    idValorRemuneracao: '0',
    observacao: '',
    engressoTrabalhoInfantil: '',
    atividadeTrabalhoInfantil: '',
    profissionalizacao: '',
    cursoProfissionalizante: '',
    renda: {
      id: 0,
      descricao: '',
    },
  },
  meioAbertoAcompInfoSaudeIntegral: {
    vinculadoUnidadeSaude: '',
    unidadeSaude: '',
    clinicaDeFamiliaDeReferencia: '',
    possuiPlanoParticular: '',
    projetoTerapeuticoSingularOuSaudeCompUnSaude: '',
    possuiDoencaCronica: '',
    doencasCronicas: '',
    possuiDeficiencia: '',
    deficiencia: '',
    possuiAcompanhamentoSaudeMental: '',
    acompanhamentoSaudeMental: '',
    unidadeSaudeMental: '',
    fazUsoDrogasLicitasIlicitas: '',
    substancias: {
      usaBebida: 'N',
      usaCigarro: 'N',
      usaCocaina: 'N',
      usaCrack: 'N',
      usaHaxixe: 'N',
      usaHeroina: 'N',
      usaLolo: 'N',
      usaMaconha: 'N',
      usaOutros: 'N',
      usaSubstancia: 'N',
    },
    relacaoAdolescenteDroga: '',
    avaliacaoResponsaveisUsoDroga: '',
    possuiLaudoDeficienciaIntelectual: '',
    revisaoMedicaTranstornoOuDeficienciaIntelectual: '',
    obsevacoes: '',
  },
  meioAbertoAcompInfoCulturaEsporte: {
    areaInteresseCultura: '',
    possuiIdJovemParaAtividadesCulturais: '',
    areaInteresseEsporte: '',
    observacoes: '',
  },
  meioAbertoAcompInfoRedeSocioassistencial: {
    crasReferencia: '',
    participaServConvFortaleciementoVinculo: '',
    participaProjetosSociais: '',
    atividadeProjetoSocial: '',
    familiaAcompanhaOutroServico: '',
    familiaInseridaCadUnico: '',
    familiaBeneProgTransfRendaFederal: '',
    adolescenteBeneBPC: '',
    familiaAtendidaOutroProgSociais: '',
    programaOuBeneficiosSociais: '',
  },
}
